import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-60e184ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "list-menu-item__title" }


import { IListSelectMenuItemProps } from './list-select.types';
import stateLayer from '@/common/components/helper-components/state-layer/state-layer.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'list-select-menu-item',
  props: {
    props: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("li", {
    class: _normalizeClass([
            'list-menu-item',
            __props.props.isSelected ? 'list-menu-item_selected' : '',
        ])
  }, [
    _createVNode(stateLayer, { class: "list-menu-item__state-layer" }, {
      default: _withCtx(() => [
        _createElementVNode("p", _hoisted_1, _toDisplayString(__props.props.title), 1)
      ]),
      _: 1
    })
  ], 2))
}
}

})